import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
//Components
import TextField from '../../../../components/TextField/TextField';
import TabelaListaGeradores from './TabelaListaGeradores';
//Api
import rotaColeta_api from '../../../../api/rotaColeta_api';
import programacaoColeta_api from '../../../../api/programacaoColeta_api';
//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
function initialStateGerador() {
    return {
        id: "",
        sequencia: "",
        status: "",
        tbGeradores_Id: "",
        tbGeradorLocalidade_id: "",
        cnpj: "",
        idetificacaoLocalidade: "",
        enderecoCompleto: "",
        tbTipoColeta_Descricao: "",
        tbTipoColeta_Id: "",
        latitude: "",
        longitude: "",
        excluido: "",
    }
}
export default function ListaGeradores({ permissao, openForm, setOpenForm, ordemColeta, setOrdemColeta }) {
    const [errors, setErrors] = useState({});
    //Estado que guarda as localidades que vieram da rota de get pelas modalidades e bairro
    const [localidades, setLocalidades] = useState([]);
    //Estado que guarda as opções do select de geradores
    const [optionsGeradores, setOptionsGeradores] = useState([]);
    //Estado que guarda o gerador selecionado
    const [optionGerador, setOptionGerador] = useState({});
    //Estado que guarda os dados para adicionar um gerador a lista
    const [gerador, setGerador] = useState(initialStateGerador());

    //Estado que guarda as opções do select de modalidades
    const [optionsModalidade, setOptionsModalidade] = useState([]);

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "modalidadeId", required: true }),
    ]

    //Carrega as modalidades assim que iniciado
    useEffect(() => {
        setOptionsModalidade([]);
        rotaColeta_api.GetModalidadesContratosPorVeiculo(ordemColeta.tbVeiculos_Id).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id.toString(), text: value.descricao }
            });
            setOptionsModalidade([{ text: "Selecione", value: "" }, ...response.data]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error")
        })
    }, [ordemColeta.tbVeiculos_Id]);
    //Change da modalidade de coleta
    const onChangeModalidade = (e) => {
        const { name, value } = e.target;
        setGerador(initialStateGerador);
        setLocalidades([]);
        setOptionsGeradores([]);
        setOptionGerador({});
        if (value != "") {
            programacaoColeta_api.GetListAllGeradoresProgramacaoOrdem(value).then(response => {
                const localidades = [];
                response.data.map(value => {
                    const localidade = ordemColeta.items.filter(g => g.tbGeradorLocalidade_id === value.idLocalidade && g.tbTipoColeta_Id == value.idTipoColeta);
                    if (localidade.length === 0) {
                        value.cnpj = mascaras.cpfcnpjMask(value.cnpj);
                        value.enderecoLabel = value.cnpj + " | " + value.fantasia + " | " + value.endereco;
                        const localidade = {
                            sequencia: value.sequencia,
                            status: value.statusItem,
                            tbGeradores_Id: value.idGerador,
                            tbGeradorLocalidade_id: value.idLocalidade,
                            cnpj: value.cnpj,
                            idetificacaoLocalidade: value.fantasia,
                            enderecoCompleto: value.endereco,
                            enderecoLabel: value.enderecoLabel,
                            tbTipoColeta_Descricao: value.tipoColeta,
                            tbTipoColeta_Id: value.idTipoColeta,
                            latitude: value.latitude,
                            longitude: value.longitude,
                            excluido: false,
                        }
                        localidades.push(localidade);

                    } else if (ordemColeta.items.filter(value => value.tbGeradorLocalidade_id === localidade[0].tbGeradorLocalidade_id).length > 0) {
                        localidades.push(localidade[0]);
                    }
                });
                setLocalidades(localidades);
                const options = localidades.map((value, index) => {

                    return { label: value.enderecoLabel, value: value.tbGeradorLocalidade_id }
                })
                setOptionsGeradores(options);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
        }
        const [modalidade] = optionsModalidade.filter(m => m.value === value);
        setGerador({
            ...gerador,
            modalidade: modalidade.text,
            [name]: value.toString()
        })
    }


    //Change para o campo de sequencia
    const onChangeSequencia = (index, value) => {
        const _ordemColeta = { ...ordemColeta };
        _ordemColeta.items.filter(value => !value.excluido)[index].sequencia = value;
        setOrdemColeta(_ordemColeta);
    }
    //Change para o campo de gerador localidade
    const onChangeGerador = (e, select) => {
        setOptionGerador(e);
        const [_gerador] = localidades.filter(l => (ordemColeta && l.tbGeradorLocalidade_id.toString() == e.value));

        setGerador({
            ..._gerador,
            modalidade: gerador.modalidade,
            modalidadeId: gerador.modalidadeId.toString()
        });
    }
    //Adiciona uma nova localidade a lista
    const adicionarLocalidade = () => {
        //Conferindo se os campos estão preenchidos corretamente
        const _errors = validarCampos(gerador, campos);
        if (!!ordemColeta && _errors[1].length > 0 || gerador.tbGeradores_Id == "") {
            setErrors({ ..._errors[0], gerador: gerador.tbGeradores_Id == "" })
            return;
        } else {
            setErrors({});
        }

        //Checando se o item ja existe na ordem de coleta e foi excluido pela variavel
        if (ordemColeta.items.filter(i => i.tbGeradorLocalidade_id === gerador.tbGeradorLocalidade_id && i.tbTipoColeta_Id == gerador.tbTipoColeta_Id).length > 0) {
            ordemColeta.items.map(value => {
                if (gerador.tbGeradorLocalidade_id === value.tbGeradorLocalidade_id) {
                    value.excluido = false;
                    return value;
                } else {
                    return value;
                }
            })
        } else {
            setOrdemColeta({
                ...ordemColeta,
                items: [...ordemColeta.items, {
                    ...gerador, sequencia: ordemColeta.items.length > 0
                        ? parseInt(ordemColeta.items[ordemColeta.items.length - 1].sequencia) + 1
                        : 1
                }]
            });
        }
        setOptionGerador({});
        setOptionsGeradores([]);
        setGerador(initialStateGerador);
    }
    //Remove um endereço da rota
    const onClickRemover = (rowData) => {
        const _ordemColeta = { ...ordemColeta }
        _ordemColeta.items = _ordemColeta.items.map(value => {
            if (rowData.tbGeradorLocalidade_id === value.tbGeradorLocalidade_id && rowData.tbTipoColeta_Id == value.tbTipoColeta_Id) {
                value.excluido = true;
                return value;
            } else {
                return value;
            }
        })
        setOrdemColeta(_ordemColeta);
    }
    return (
        <div className='mb-3'>
            <div className={`formContainer mb-4 ${openForm ? "" : "close"}`}>
                <div>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField label={"* Modalidade de coleta"} type={"select"} options={optionsModalidade} name={"modalidadeId"} value={gerador.modalidadeId} onChange={onChangeModalidade} invalid={errors.modalidadeId ? true : false} />
                        </Col>
                        <Col md="12" lg={"6"}>
                            <TextField label={"* Geradores"} type={"select"} options={optionsGeradores} searchable onChange={onChangeGerador} value={optionGerador} invalid={errors.gerador} />
                        </Col>
                    </Row>
                    <div className='d-flex align-items-center justify-content-center'>
                        <Button className='bg-gradient' color='success' onClick={adicionarLocalidade}>+ Adicionar</Button>
                        <Button className='bg-gradient  ms-3' onClick={() => {
                            setOpenForm(false)
                            setErrors({});
                        }}>Cancelar</Button>
                    </div>
                </div>
            </div>
            <TabelaListaGeradores permissao={permissao} items={ordemColeta.items} remover={onClickRemover} onChangeSequencia={onChangeSequencia} />
        </div>
    )
}